/* ==========================================================================
   OUR CRAFT — Page JS
   Loaded ONLY on /pages/the-craft (via <script> in tcb-craft-page.liquid)
   ========================================================================== */
(function () {
  'use strict';

  /* ── Scroll-reveal via IntersectionObserver ───────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.cp-reveal');
    if (!els.length) return;

    /* Respect prefers-reduced-motion */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cp-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Staggered children inside each reveal card ─────────────────── */
  function initStagger() {
    var cards = document.querySelectorAll('.cp-reveal');
    cards.forEach(function (card, i) {
      /* Tighter stagger: each card 28ms after the previous,
         capped at 180ms so later cards don't feel abandoned.
         Resets per-panel via cpSwitch so cards always feel fresh. */
      card.style.transitionDelay = Math.min(i * 0.028, 0.18) + 's';
    });
  }

  /* ── Horizontal scroll fade edges (visual hint) ───────────────────── */
  function initHscrollHints() {
    var strips = document.querySelectorAll('.cp-hscroll, .cp-timeline-wrap, .cp-fabric-strip');
    strips.forEach(function (strip) {
      /* Simple right-edge fade via mask-image, applied once */
      strip.style.maskImage = 'linear-gradient(to right, black 85%, transparent 100%)';
      strip.style.webkitMaskImage = 'linear-gradient(to right, black 85%, transparent 100%)';

      strip.addEventListener('scroll', function () {
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        if (atEnd) {
          strip.style.maskImage = 'none';
          strip.style.webkitMaskImage = 'none';
        } else {
          strip.style.maskImage = 'linear-gradient(to right, black 85%, transparent 100%)';
          strip.style.webkitMaskImage = 'linear-gradient(to right, black 85%, transparent 100%)';
        }
      }, { passive: true });
    });
  }

  /* ── Animated number count-up (runs once when card enters view) ─── */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;

    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el    = entry.target;
        var end   = parseFloat(el.getAttribute('data-countup'));
        var dur   = 1200;
        var start = performance.now();
        var from  = 0;

        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          /* Ease-out cubic */
          p = 1 - Math.pow(1 - p, 3);
          var cur = from + (end - from) * p;
          el.textContent = Number.isInteger(end) ? Math.round(cur) : cur.toFixed(1);
          if (p < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
        io2.unobserve(el);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (el) { io2.observe(el); });
  }

  /* ── Active nav link (desktop under-menu) ─────────────────────────── */
  function markNavActive() {
    var links = document.querySelectorAll('.tcb-under-menu__link');
    links.forEach(function (a) {
      if (a.getAttribute('href') === '/pages/the-craft') {
        a.classList.add('tcb-under-menu__link--craft-active');
      }
    });
  }

  /* ── Category panel switcher ────────────────────────────────────────── */
  function cpSwitch(cat, btn) {
    /* 1. Hide all panels */
    var panels = document.querySelectorAll('.cp-panel');
    panels.forEach(function (p) {
      p.classList.remove('cp-panel--active');
    });

    /* 2. Show target panel */
    var target = document.getElementById('cp-panel-' + cat);
    if (target) {
      target.classList.add('cp-panel--active');

      /* Re-arm reveal + countup on newly visible cards */
      var revealEls = target.querySelectorAll('.cp-reveal');
      revealEls.forEach(function (el, i) {
        el.classList.remove('cp-visible');
        /* Re-apply stagger so panel cards cascade in fresh */
        el.style.transitionDelay = Math.min(i * 0.028, 0.18) + 's';
      });
      /* Small wait: let panel fade-in animation start first */
      setTimeout(function () {
        initRevealIn(target);
        initCountUpIn(target);
        initHscrollHints();
      }, 80);
    }

    /* 3. Update picker button active states */
    document.querySelectorAll('.cp-picker-card').forEach(function (c) {
      var active = c.dataset.cat === cat;
      c.classList.toggle('cp-picker-card--active', active);
      c.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    /* 4. Update URL hash for deep linking */
    if (history && history.replaceState) {
      history.replaceState(null, '', '#' + cat);
    }

    /* 5. No auto-scroll — keep user's position on category switch */
  }

  /* Expose globally — called via onclick="cpSwitch(...)" in Liquid */
  window.cpSwitch = cpSwitch;

  /* ── Reveal scoped to a container (for panel switching) ─────────────── */
  function initRevealIn(container) {
    var els = (container || document).querySelectorAll('.cp-reveal:not(.cp-visible)');
    if (!els.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cp-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ── CountUp scoped to a container ──────────────────────────────────── */
  function initCountUpIn(container) {
    var nums = (container || document).querySelectorAll('[data-countup]');
    if (!nums.length) return;

    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el  = entry.target;
        var end = parseFloat(el.getAttribute('data-countup'));
        var dur = 1200;
        var s   = performance.now();

        function tick(now) {
          var p = Math.min((now - s) / dur, 1);
          p = 1 - Math.pow(1 - p, 3);
          el.textContent = Number.isInteger(end) ? Math.round(end * p) : (end * p).toFixed(1);
          if (p < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
        io2.unobserve(el);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (el) { io2.observe(el); });
  }

  /* ── Deep-link hash routing ──────────────────────────────────────────── */
  function initHash() {
    var hash  = window.location.hash.replace('#', '');
    var valid = ['shirts', 'jackets', 'suits', 'trousers'];
    if (hash && valid.indexOf(hash) !== -1) {
      setTimeout(function () {
        var btn = document.querySelector('.cp-picker-card[data-cat="' + hash + '"]');
        cpSwitch(hash, btn);
      }, 200);
    }
  }

  /* ── Init ─────────────────────────────────────────────────────────── */
  function boot() {
    initStagger();
    initReveal();
    initRevealIn();
    initHscrollHints();
    initCountUp();
    initCountUpIn();
    markNavActive();
    initHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());

/* ═══════════════════════════════════════════════════════════════
   MODAL SYSTEM — tap any card to expand (Apple Weather style)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── HTML builders ──────────────────────────────────────────── */
  function intro(txt) { return '<p class="cp-m-intro">' + txt + '</p>'; }
  function text(txt)  { return '<p class="cp-m-text">' + txt + '</p>'; }
  function subhdr(t)  { return '<div class="cp-m-subhdr">' + t + '</div>'; }

  function stat(n, u, l, b) {
    return '<div class="cp-m-stat"><div class="cp-m-snum">' + n + '<span class="cp-m-sunit">' + u + '</span></div>' +
           '<div><div class="cp-m-slabel">' + l + '</div><div class="cp-m-sbody">' + b + '</div></div></div>';
  }

  function compare(rows) {
    var r = '<div class="cp-m-compare"><div class="cp-m-compare-hdr"><span>Detail</span><span>TCB</span><span>Industry</span></div>';
    rows.forEach(function(row) {
      r += '<div class="cp-m-compare-row"><span class="cp-m-ck">' + row[0] + '</span><span class="cp-m-ct">' + row[1] + '</span><span class="cp-m-co">' + row[2] + '</span></div>';
    });
    return r + '</div>';
  }

  function steps(items) {
    return items.map(function(s) {
      return '<div class="cp-m-step"><div class="cp-m-stepn">' + s[0] + '</div><div><div class="cp-m-stept">' + s[1] + '</div><div class="cp-m-stepb">' + s[2] + '</div></div></div>';
    }).join('');
  }

  function grid(items) {
    var r = '<div class="cp-m-grid">';
    items.forEach(function(i) {
      r += '<div class="cp-m-grid-item"><div class="cp-m-grid-icon">' + i[0] + '</div><div class="cp-m-grid-title">' + i[1] + '</div><div class="cp-m-grid-val">' + i[2] + '</div><div class="cp-m-grid-body">' + i[3] + '</div></div>';
    });
    return r + '</div>';
  }

  function mtmRows(items) {
    return items.map(function(i) {
      return '<div class="cp-m-mrow"><div class="cp-m-mnum">' + i[0] + '</div><div class="cp-m-mlabel">' + i[1] + '</div><div class="cp-m-mdesc">' + i[2] + '</div></div>';
    }).join('');
  }

  function cta(href, label) {
    return '<div class="cp-m-cta-row"><a href="' + href + '" class="cp-m-cta-link">' + label + '</a></div>';
  }

  /* ── Modal content registry ──────────────────────────────────── */
  var M = {};

  /* ════════ SHIRTS ════════ */

  M['shirts-glance'] = {
    icon: '⚡', title: 'Shirts — At a Glance',
    html: function() {
      return stat('<span style="font-size:1.25rem;line-height:1.2">24–28</span>', 'SPI', 'Stitch Density',
          'The industry standard is 14–18 stitches per inch. At 24–28, seam lines are finer, thread tension per stitch is lower, and the hem sits close enough to invisible when tucked. Seams last longer because each thread bears less load.') +
        stat('20+', 'hrs / shirt', 'Handwork',
          'Those hours go into collar shaping, cuff attachment, interlining construction, buttonhole work, armhole stitching, pick stitching, and a complete quality review of every finished seam.') +
        subhdr('Hand Sewn — Five Details') +
        text('Interlining · Armholes · Buttonholes · MOP Buttons · Pick Stitching') +
        text('Five critical details worked entirely by hand. Each contributes to fit, structure, durability, or finish — none are visible in a photograph.') +
        subhdr('TCB Sewn-In Interlining') +
        text('Sewn-in cotton layers at collar and cuff — not iron-on adhesive. No glue against your skin. No bubbling with washing. Shape maintained for the life of the garment.');
    }
  };

  M['shirts-quote'] = {
    icon: '—', title: 'The Approach',
    html: function() {
      return intro('The difference is in the details you <em>cannot see.</em>') +
        text('The interlining pressed against your neck and wrists all day. The thread tension at the hem. The elasticity of a buttonhole that allows the button to pass without cutting threads. These are not visible in photographs. They are only apparent when you put the shirt on.') +
        text('That is where we work.');
    }
  };

  M['shirts-journey'] = {
    icon: '📍', title: 'From Studio to You',
    html: function() {
      return steps([
        ['01', 'Design', 'Pattern drafted in-house using 2D flat construction and 3D fit testing. No licensed blocks from external pattern services.'],
        ['02', 'Fabric Selection', 'Woven fabric sourced from established mills. Thread color, weight, and fiber content selected individually per style.'],
        ['03', 'Cutting', 'Each panel cut by hand against the pattern. Grain direction matched on every piece.'],
        ['04', 'Construction', '20+ hours of handwork per shirt. Collar and cuff interlining sewn in. All seams run at 24 to 28 stitches per inch.'],
        ['05', 'Buttonholes', 'Worked by hand in silk thread. The cut edge is wrapped and sealed — giving the hole natural elasticity and sealing against fraying. Each one inspected for consistency before the shirt moves to the next stage.'],
        ['06', 'Quality Check', 'Every seam, button, buttonhole, and hem reviewed before dispatch. Any inconsistency corrected in the studio.'],
        ['07', 'Dispatch', 'Ships from New York. Shirts pressed and folded. MTM orders confirmed with the team before construction begins.']
      ]);
    }
  };

  M['shirts-feature'] = {
    icon: '🧵', title: 'TCB Sewn-In Interlining',
    html: function() {
      return intro('No adhesive. Cotton sewn directly into the structure.') +
        text('Nearly every dress shirt on the market — regardless of price — fuses its collar and cuffs with iron-on adhesive. A sheet of synthetic glue is pressed between the outer fabric and an inner layer, creating stiffness. That material sits against your neck and wrists all day.') +
        text('We engineered a proprietary alternative: a soft yet structured collar and cuff support system built from sewn-in cotton layers, designed and developed in-house at TCB. Exceptional structure without stiffness. Natural breathability without compromise. No glue rubs against your skin. Collars and cuffs hold their shape through repeated wear — no bubbling, no yellowing from glue oxidation. Shape that lasts the life of the garment, through every wash.') +
        text('<em>The collar and cuff are where most shirts fail. Ours are engineered to outlast the fabric around them.</em>') +
        subhdr('TCB vs. Industry') +
        compare([
          ['Structure method', 'Sewn cotton layers', 'Iron-on adhesive'],
          ['Against your skin', 'Natural cotton', 'Synthetic fusing agent'],
          ['After 50 washes', 'Unchanged', 'Risk of bubbling / delamination'],
          ['Repairability', 'Fully repairable', 'Cannot be reversed'],
          ['Feel over time', 'Softens with wear', 'May stiffen or harden'],
          ['Durability', 'Life of the garment', 'Degrades over time']
        ]);
    }
  };

  M['shirts-techniques'] = {
    icon: '🏗', title: 'Shirt Techniques',
    html: function() {
      return grid([
        ['📐', 'Pattern Drafting', '2D + 3D', 'In-house engineering. No external pattern licenses.'],
        ['🧵', 'Sewn-In Interlining', 'Cotton', 'No adhesive. Cotton layers sewn directly into collar and cuff.'],
        ['🎨', 'Thread Selection', 'Per Garment', 'Color, weight, and fiber chosen for each style individually.'],
        ['⚡', 'Stitch Density', '24–28 SPI', 'Standard is 14–18. At 24–28, seams are finer, softer, and longer-lasting.'],
        ['🪡', 'Buttonholes', 'Hand · Silk', 'Worked by hand in silk thread. Cut edge wrapped and sealed — natural elasticity, no fraying.'],
        ['🔘', 'Buttons', 'MOP / Horn', 'Three-point stitch. Hand-formed thread shank on every button.'],
        ['👁️', 'Hem', 'Invisible', 'Near-seamless finish. Sits flat when tucked.'],
        ['🎨', 'Collar Shaping', 'Hand-shaped', 'Set and shaped by hand before final attachment.']
      ]);
    }
  };

  M['shirts-26spi'] = {
    icon: '⚡', title: 'Stitch Density — 24–28 SPI',
    html: function() {
      return intro('24 to 28 stitches per inch. The standard is 14–18.') +
        text('At 24 to 28 stitches per inch, each individual stitch is smaller and the thread is under less tension. Seam lines are finer — close to invisible on a well-finished hem. The stitch spacing is tight enough that the seam moves with the fabric rather than resisting it.') +
        text('The practical result: side seams that sit flat against the body, hems that are nearly invisible when tucked, and seams that last longer because no single thread bears excessive load.') +
        subhdr('Comparison') +
        compare([
          ['Stitch density', '24–28 SPI', '14–18 SPI (standard)'],
          ['Hem visibility', 'Near invisible', 'Visible stitch line'],
          ['Seam flexibility', 'Moves with fabric', 'Stiffer seam profile'],
          ['Seam longevity', 'Lower stress per thread', 'Higher stress per thread'],
          ['Handwork hours', '20+ per shirt', '2–4 typical']
        ]);
    }
  };

  M['shirts-20min'] = {
    icon: '🪡', title: 'Buttons & Buttonholes',
    html: function() {
      return intro('Worked by hand in silk thread. The most considered detail on the shirt.') +
        subhdr('The Buttonhole') +
        text('A machine buttonhole is cut and stitched in under five seconds using a programmed pattern. The thread is cut at each corner. There is no elasticity — the hole cannot flex with the fabric, and the exposed cut threads at each corner fray under repeated use.') +
        text('Each TCB buttonhole is worked entirely by hand using silk thread in a keyhole pattern. A small round eye is pierced at one end — this is where the button shank sits and bears all the tension. The cut edge is then wrapped in continuous silk thread without stopping at the corners, forming a firm welt around the full perimeter of the opening. The result has natural elasticity: the fabric stretches to receive the button and recovers cleanly. No corner stress points. No raw threads.') +
        text('Silk is the correct thread for this work. It is stronger than cotton relative to its weight, smoother under tension, and its natural elasticity means the thread moves with the buttonhole rather than fighting it. The wrapped edge will not harden, crack, or separate from the fabric over time.') +
        subhdr('The Button') +
        text('Buttons are sewn with a hand-formed thread shank — a loop of thread built up between the button face and the placket before the final stitches are drawn through. This shank holds the button clear of the fabric when fastened, preventing the placket from pulling flat and allowing the button to enter the hole at the correct angle without forcing the edges apart.') +
        text('Mother-of-Pearl is standard. It is a natural material — no two buttons are identical — with a surface that is smooth without being cold, and a weight that sits correctly against the placket. Natural horn is available on request; it carries a warmer, more textured character suited to casual or sport shirt constructions.') +
        subhdr('TCB vs. Industry') +
        compare([
          ['Buttonhole method', 'Hand-worked · silk', 'Machine cut · 4 sec'],
          ['Hole shape', 'Keyhole — round eye', 'Rectangular slit'],
          ['Edge finish', 'Wrapped continuously', 'Cut thread at corners'],
          ['Elasticity', 'Natural flex with wear', 'Rigid · no give'],
          ['Longevity', 'Sealed · does not fray', 'Frays at corners over time'],
          ['Button attachment', 'Thread shank · hand-sewn', 'Machine-sewn flat'],
          ['Thread', 'Silk', 'Polyester'],
          ['Button material', 'MOP or natural horn', 'Plastic']
        ]);
    }
  };

  M['shirts-personalization'] = {
    icon: '✦', title: 'Make It Yours',
    html: function() {
      return intro('Every ready-to-wear shirt can be made personal before it ships.') +
        subhdr('Button Colour') +
        text('Select your preferred button colour at checkout. Mother-of-Pearl is standard — available in white, ivory, or smoke. Natural horn available as an alternative. Applied to the shirt before dispatch, at no additional charge.') +
        subhdr('Monogram') +
        text('Your initials embroidered in silk thread. Placement options: cuff placket, chest pocket, or inner collar. Thread colour chosen to complement the fabric. The monogram is a private detail — invisible to others, specific to you.') +
        subhdr('Gift Packaging') +
        text('Every TCB shirt is gift-ready by default. Select the gift option at checkout — the shirt is presented in our signature box with a handwritten card. No pricing included unless specifically requested. Monogramming is available for gift orders.') +
        cta('/pages/contact', 'Enquire About Personalisation →');
    }
  };

  M['shirts-inbox'] = {
    icon: '📦', title: "What's in the Box",
    html: function() {
      return intro('Every order leaves the studio complete and considered.') +
        grid([
          ['👔', 'Your Shirt', 'Pressed · Folded', 'Inspected in the studio before packing. Folded and wrapped in tissue — ready to wear.'],
          ['🧺', 'TCB Travel Bag', 'Cotton · Branded', 'A TCB cotton fabric bag sized for a folded shirt. Keeps the shirt clean and compact in luggage — reusable and washable.'],
          ['🔘', 'Extra Buttons', 'Matched Set', 'MOP or horn buttons matched exactly to your shirt. Secured in an envelope — one set included with every order.'],
          ['🪵', 'Cedar Block', 'Natural · Reusable', 'Cedar wood block included in every box. Naturally deters moths, absorbs moisture, and keeps stored shirts fresh between wears.'],
          ['📋', 'Care Card', 'Garment-specific', 'Laundering, ironing, and storage instructions specific to the construction of your shirt.'],
          ['📦', 'Shipping Box', 'Branded', 'All items dispatched in our branded shipping box. If gift packaging is selected, the wrapped gift is enclosed inside the shipping box.']
        ]);
    }
  };

  M['shirts-compare'] = {
    icon: '◼', title: 'TCB vs. Industry Standard',
    html: function() {
      return subhdr('Construction') +
        compare([
          ['Collar / Cuff interlining', 'Sewn-in cotton', 'Iron-fused adhesive'],
          ['Interlining durability', 'Life of garment', 'Bubbles & degrades with wash'],
          ['Stitch density', '24–28 SPI', '14–18 SPI'],
          ['Handwork', '20+ hours per shirt', '2–4 hours typical'],
          ['Buttonholes', 'Hand-worked · silk thread', 'Machine cut · 4 seconds'],
          ['Buttons', 'MOP or horn · thread shank', 'Plastic · machine-sewn'],
          ['Pick stitching', 'Hand pick-stitched edges', 'Machine topstitch or none'],
          ['Production', 'New York · handmade', 'Overseas factory']
        ]);
    }
  };

  M['shirts-mtm'] = {
    icon: '📐', title: 'Made to Measure — Shirts',
    html: function() {
      return intro('6 measurements. 3–4 weeks. Cut to your proportions.') +
        text('Made to Measure is +$200 over the ready-to-wear price. A virtual fitting is available — book a call and the team confirms your measurements before construction begins.') +
        subhdr('What is measured') +
        mtmRows([
          ['1', 'Neck', 'Collar circumference'],
          ['2', 'Chest', 'Full chest circumference'],
          ['3', 'Waist', 'Shirt waist, not trouser'],
          ['4', 'Sleeve', 'Shoulder point to wrist bone'],
          ['5', 'Shoulder', 'Point to point across back'],
          ['6', 'Body Length', 'Back neck to preferred hem']
        ]) +
        subhdr('Process') +
        steps([
          ['01', 'Submit measurements', 'Measurements sent via the concierge form or a call with the team.'],
          ['02', 'Team review', 'Team confirms within 24 hours. Questions resolved before construction begins.'],
          ['03', 'Construction', '3–4 weeks. Same methods as ready-to-wear — 24–28 SPI, sewn-in interlining, hand buttonholes.'],
          ['04', 'Delivery + alteration window', 'One free alteration within 30 days of delivery. MTM orders are final sale.']
        ]) +
        cta('/pages/made-to-measure', 'Explore Made to Measure →');
    }
  };

  M['shirts-fit'] = {
    icon: '🎯', title: 'Sculpted Fit — Shirts',
    html: function() {
      return intro('Shaped — not sewn flat. The fit is in the pattern.') +
        text('The TCB shirt silhouette is not a standard block adjusted for size. Every curve — through the body, at the collar stand, along the shoulder — is designed specifically. The fit is a consequence of the pattern, not the fabric pulling against it.') +
        subhdr('How the fit is designed') +
        stat('Body', 'Curve', 'Side Seam Taper', 'The side seam narrows through the waist and releases at the hip. The shirt follows the body through movement rather than holding a rigid shape against it.') +
        stat('Collar', 'Architecture', 'Stand and Spread', 'Stand height and spread are designed to frame the neck and sit cleanly against a jacket lapel. No gap at the back. No curling away through the day.') +
        stat('Shoulder', 'Placement', 'Sleeve Pitch', 'The sleeve is set at a precise pitch. The seam sits at the shoulder point — not shifted. The sleeve hangs clean without pulling across the chest.') +
        stat('Tuck', 'Length', 'Hem Curve', 'The hem is long enough to stay tucked through movement but not so long it bunches at the waist. The curve is designed for this — not arrived at by chance.');
    }
  };

  M['jackets-fit'] = {
    icon: '🎯', title: 'Sculpted Fit — Jackets',
    html: function() {
      return intro('A fit that belongs to you. And improves over time.') +
        text('The TCB jacket does not hold the shape it left the factory in. The full linen canvas is alive — it responds to heat, movement, and posture. Over time it develops a drape specific to you. Not just your size. You.') +
        subhdr('How the fit is built') +
        stat('Chest', '+ Waist', 'In the Pattern', 'Chest projection and waist suppression are built into the cut — not added with padding or stiffening. The silhouette is a consequence of proportion.') +
        stat('Lapel', 'Roll', 'Develops Over Time', 'Set and rolled by hand. As the canvas settles, the lapel develops a natural roll shaped by how you move. No two are the same after a season of wear.') +
        stat('Shoulder', '+ Sleeve', 'Pitch and Fall', 'Natural shoulder — no padding to manufacture width. The sleeve is pitched to hang straight without pulling forward at rest or during movement.') +
        stat('Canvas', 'Fit', 'Improves With Wear', 'A fused jacket holds the factory shape — then slowly loses it. A TCB jacket starts well and improves, settling into a fit that becomes increasingly yours.');
    }
  };

  M['suits-fit'] = {
    icon: '🎯', title: 'Sculpted Fit — Suits',
    html: function() {
      return intro('Two pieces. One silhouette. Engineered together.') +
        text('A suit\'s fit is not just how each piece fits individually — it is how the jacket and trouser work together. Both are designed as a system. Jacket hem length, trouser rise, and seat of each piece are all considered against each other before cutting begins.') +
        subhdr('How the fit works across both pieces') +
        stat('Proportions', 'Across', 'Both Pieces', 'Jacket hem length is designed against the trouser rise. The seat of the jacket accounts for the trouser beneath it. The silhouette is one — not two garments that happen to match.') +
        stat('Canvas', 'Fit', 'Develops Over Time', 'The linen canvas molds to the chest and shoulder with each wear — the jacket fit improves rather than degrades, growing more specific to the wearer over time.') +
        stat('Trouser', 'Drape', 'Off the Jacket Hem', 'The silk-lined front falls cleanly from the jacket hem — no resistance, no bunching at the thigh. The trouser break is considered against the jacket\'s length.') +
        stat('Back Vent', '+ Seat', 'Engineered Together', 'The jacket vent is cut to work with the trouser seat — it releases cleanly when seated rather than riding up or pulling across the hips.');
    }
  };

  M['trousers-fit'] = {
    icon: '🎯', title: 'Sculpted Fit — Trousers',
    html: function() {
      return intro('The trouser you stop thinking about.') +
        text('A well-fitting trouser disappears. The waistband stays where it starts. The seat does not pull. The thigh has room without excess. The crease holds. Every proportion in a TCB trouser is designed to achieve this — not left to chance.') +
        subhdr('How the fit is designed') +
        stat('Rise', '+ Seat', 'In Proportion', 'Rise determines where the trouser sits. The seat is shaped to follow without pulling when seated. These two dimensions are designed in relation to each other — not set independently.') +
        stat('Leg', 'Line', 'Thigh to Hem', 'Width at the thigh, knee, and hem is designed in proportion. The leg reads as a clean, deliberate line. The crease holds because the grain is cut correctly.') +
        stat('Drape', 'Off the', 'Waistband', 'The silk-lined front allows the trouser to hang cleanly — fabric falls, does not cling, bunch, or pull across the knee throughout the day.') +
        stat('Flat', 'Front', 'By Design', 'The front panel is cut flat and the closure keeps it that way. One uninterrupted plane from waistband to thigh — no bunching, no visual disruption.');
    }
  };

  M['shirts-construction'] = {
    icon: '🏗', title: 'Shirt Construction',
    html: function() {
      return grid([
        ['📐', 'Pattern Drafting', '2D + 3D', 'In-house engineering. No external pattern licenses. Every element specific to TCB.'],
        ['🧵', 'Sewn-In Interlining', 'Cotton', 'No adhesive. Cotton layers sewn directly into collar and cuff. Shape holds for life.'],
        ['⚡', 'Stitch Density', '24–28 SPI', 'Standard is 14–18. Finer seams, softer feel, lower tension per thread.'],
        ['🪡', 'Buttonholes', 'Hand · Silk', 'Keyhole cut, wrapped edge, natural elasticity. No machine cut. No exposed corners.'],
        ['🔘', 'Buttons', 'MOP / Horn', 'Three-point stitch. Hand-formed thread shank on every button. Silk thread.'],
        ['✍️', 'Pick Stitching', 'Hand', 'Fine pick stitching along all shirt edges. Same technique as TCB jackets.'],
        ['👁️', 'Hem', 'Invisible', 'Near-seamless finish. Sits flat and disappears when tucked.'],
        ['🎨', 'Thread Selection', 'Per Garment', 'Color, weight, fiber chosen individually. Silk for buttons; construction thread matched per style.']
      ]);
    }
  };

  M['shirts-materials'] = {
    icon: '🪢', title: 'Shirt Materials',
    html: function() {
      return grid([
        ['🏭', 'Outer Fabric', 'Premium mill', 'Sourced from established woven-fabric mills. Weight and weave selected per style.'],
        ['🌸', 'Interlining', 'Cotton layers', 'Sewn into collar and cuff. No synthetic fusing agents.'],
        ['🥚', 'Thread', 'Silk', 'Used for buttonholes and button attachment. Natural fiber, consistent tension.'],
        ['🐚', 'Buttons (default)', 'Mother-of-Pearl', 'Natural material. Polished finish. Sewn with silk thread shank.'],
        ['🦌', 'Buttons (alternative)', 'Natural Horn', 'Sustainable natural material. Warmer tone. Available on request.'],
        ['🎯', 'Button attachment', '3-point stitch', 'Three anchor points per button. Thread shank formed by hand for clearance.']
      ]);
    }
  };

  M['shirts-nyc'] = {
    icon: '📍', title: 'New York Workshop',
    html: function() {
      return intro('Designed. Cut. Finished. All in New York City.') +
        text('Every garment is made in the same studio where it was designed. The person who cut the pattern and the person who finished the buttonhole work in the same room. No production is outsourced.') +
        text('The studio opened in 2019. Every production decision since then has been made to maintain that standard — not to scale at the expense of it.');
    }
  };

  M['shirts-care'] = {
    icon: '🫧', title: 'Shirt Care',
    html: function() {
      return grid([
        ['🫧', 'Laundering', 'Professional laundering recommended', 'Cold delicate machine wash acceptable. Hang to dry. Never tumble dry.'],
        ['🌡️', 'Ironing', 'Medium heat', 'Iron while slightly damp. The sewn-in interlining holds shape — no special collar treatment needed.'],
        ['🚫', 'Bleach', 'Never', 'Weakens silk thread and damages the cotton interlining over repeated use.'],
        ['🪵', 'Storage', 'Wide wooden hanger', 'The interlining does not degrade. The collar holds its shape without special storage.'],
        ['💧', 'Stain treatment', 'Cold water, immediately', 'Blot — do not rub. Hot water sets protein-based stains permanently.'],
        ['📦', 'Travel', 'Roll or fold flat', 'The 24–28 SPI seams resist creasing better than standard-density seams.']
      ]);
    }
  };

  /* ════════ JACKETS ════════ */

  M['jackets-glance'] = {
    icon: '⚡', title: 'Jackets — At a Glance',
    html: function() {
      return stat('Full', 'Canvas', 'Chest Structure',
          'Most jackets use a fused or half-canvas chest piece. A full linen canvas spans the entire chest and lapel and is hand pad-stitched — it molds to your body over time rather than holding a fixed rigid shape.') +
        stat('Hand', 'Pad-Stitched', 'Chest & Lapel',
          'Hundreds of individual hand stitches anchor the canvas to the chest piece and shape the lapel. This is the step that distinguishes full-canvas construction from everything else at the production level.') +
        stat('7', 'measurements', 'MTM Precision',
          'Chest, waist, seat, shoulder width, sleeve length, back length, neck. Seven points mapped before construction begins.') +
        stat('3–4', 'weeks', 'MTM Construction',
          'Same methods as ready-to-wear. Linen canvas, hand pad-stitching, working sleeve vents, hand pick stitching on all edges.');
    }
  };

  M['jackets-quote'] = {
    icon: '—', title: 'The Approach',
    html: function() {
      return intro('From the precision of the lapels to the <em>hand-stitched silk buttonholes</em>, each detail reveals itself differently in every dimension.') +
        text('A full-canvas jacket does something a fused jacket cannot: it responds to your body. The canvas yields where your chest moves, returns where it should, and over time develops a drape that is specific to you.') +
        text('That is not a feature. It is what the garment does when it is built correctly.');
    }
  };

  M['jackets-journey'] = {
    icon: '📍', title: 'From Studio to You',
    html: function() {
      return steps([
        ['01', 'Design', 'Pattern drafted in-house using 2D and 3D methods. Jacket and lining patterns engineered together.'],
        ['02', 'Fabric selection', 'Outer fabric, canvas, and lining sourced separately. Canvas weight and padding adjusted per style.'],
        ['03', 'Cutting', 'All panels — outer, canvas, lining — cut against individual patterns. Grain direction matched.'],
        ['04', 'Canvas work', 'Full linen canvas assembled and pad-stitched by hand. The chest piece is shaped at this stage.'],
        ['05', 'Assembly', 'Outer, canvas, and lining joined. Lapels rolled and hand-set. Edges hand pick-stitched.'],
        ['06', 'Finishing', 'Sleeve vents set. Buttons and buttonholes completed. Blind hem hand-stitched.'],
        ['07', 'Quality check', 'Canvas drape, lapel roll, seam consistency, and button placement all reviewed before dispatch.']
      ]);
    }
  };

  M['jackets-feature'] = {
    icon: '🏗', title: 'Full Linen Canvas',
    html: function() {
      return intro('Structure that molds to your body. Not glued in place.') +
        text('A fused jacket has a chest piece bonded with adhesive. It holds a shape — the shape it was pressed into at the factory. Over time and with heat, fused jackets can delaminate. The chest piece stiffens or separates.') +
        text('A full-canvas jacket has a linen chest piece anchored by hand pad-stitching. It has structure, but that structure responds — it yields where you move and recovers. Over time it develops a drape specific to how you wear it. It improves.') +
        subhdr('Canvas type comparison') +
        compare([
          ['Canvas coverage', 'Full — chest to hem', 'Half or none'],
          ['Chest shaping', 'Hand pad-stitched', 'Machine glued'],
          ['Lapel roll', 'Hand-rolled canvas', 'Pressed flat / fused'],
          ['Body fit over time', 'Molds to wearer', 'Fixed factory shape'],
          ['With heat / age', 'Improves and settles', 'May stiffen or delaminate']
        ]);
    }
  };

  M['jackets-construction'] = {
    icon: '🏗', title: 'Jacket Construction',
    html: function() {
      return grid([
        ['📐', 'Pattern Drafting', 'In-House', 'Both jacket and lining patterns engineered together in the studio.'],
        ['🏗️', 'Full Linen Canvas', 'Hand-Stitched', 'Spans the full chest. Pad-stitched and rolled by hand.'],
        ['✍️', 'Pick Stitching', 'All Edges', 'Fine hand stitching along all jacket edges. Signature detail.'],
        ['👁️', 'Hem', 'Blind Stitch', 'Hand-finished blind hem. Clean, controlled fall.'],
        ['🎨', 'Thread Selection', 'Per Garment', 'Color, weight, and fiber matched to the outer fabric.'],
        ['🪡', 'Buttons', 'MOP / Horn', 'Three-point stitch. Hand-formed thread shank. Silk thread.'],
        ['🔧', 'Sleeve Vents', 'Working', '4 stacked buttons per sleeve. Functional, not decorative.'],
        ['🧠', 'Inner Pockets', 'Chest + side', 'Chest pocket sized for a current iPhone model.']
      ]);
    }
  };

  M['jackets-techniques'] = {
    icon: '🏗', title: 'Jacket Techniques',
    html: function() {
      return grid([
        ['🏗️', 'Canvas', 'Full Linen', 'Spans chest and lapel. Pad-stitched by hand.'],
        ['🤝', 'Pad-Stitching', 'By Hand', 'Hundreds of individual stitches shape the chest piece.'],
        ['🌀', 'Lapel Roll', 'Hand-Rolled', 'Set by hand. Develops and settles with wear.'],
        ['✍️', 'Pick Stitching', 'All Edges', 'Fine hand work along every jacket edge.'],
        ['🔧', 'Sleeve Vents', 'Working', '4 functional buttons per sleeve.'],
        ['🪡', 'Buttonholes', 'Silk Thread', 'Hand-sewn. Each one worked individually.'],
        ['👁️', 'Hem', 'Blind Stitch', 'Hand-finished. Invisible from the outside.'],
        ['🎨', 'Lining', 'Silk / Bemberg', 'Matched per style. Applied after outer assembly.']
      ]);
    }
  };

  M['jackets-4buttons'] = {
    icon: '🔧', title: 'Working Sleeve Buttons',
    html: function() {
      return intro('4 working buttons per sleeve. Not decorative.') +
        text('On most jackets — including many at elevated price points — sleeve buttons are sewn flat to closed sleeves. They cannot be undone. They exist for appearance only.') +
        text('Our jackets have fully functional sleeve vents. All four buttons open. The sleeve can be rolled. Sleeve shortening is available as a service (+$300) and includes re-cutting the vent and hand-sewing new buttonholes to match.') +
        text('Functional working buttons on a sleeve vent are a standard feature of traditional tailoring. They are absent from most ready-to-wear because they require cutting a proper vent and finishing it correctly — steps that add time and cost.');
    }
  };

  M['jackets-lifespan'] = {
    icon: '🛡', title: 'Canvas Lifespan',
    html: function() {
      return intro('A full-canvas jacket improves. A fused jacket deteriorates.') +
        text('The linen canvas in a full-canvas jacket is a structural component — it is not glued. Heat, moisture, and compression do not cause it to fail. Over time, it settles and molds to the specific contours of the wearer.') +
        text('A fused jacket uses adhesive to bond the chest piece to the outer fabric. That bond is weakened by dry cleaning solvents, heat, and repeated compression. The failure mode is visible: the outer fabric begins to bubble or the chest piece stiffens where the adhesive has set unevenly.') +
        text('With proper care, a full-canvas jacket has no functional lifespan limit. The canvas is one of the longest-lasting components in the garment.');
    }
  };

  M['jackets-materials'] = {
    icon: '🌿', title: 'Jacket Materials',
    html: function() {
      return intro('Every material selected for a reason. Every one from the earth.') +
        grid([
          ['🏭', 'Outer Fabric', 'Premium Mill', 'Sourced from established woven-fabric mills. Weight and weave selected per style.'],
          ['🌿', 'Full Linen Canvas', 'Structure', 'Spans the entire chest and lapel. Hand pad-stitched — molds to your body over time.'],
          ['✨', 'Silk / Bemberg Lining', 'Jacket interior', 'Matched per style. Applied after outer assembly for a clean, controlled drape.'],
          ['🥚', 'Silk Thread', 'Buttonholes & buttons', 'Natural fibre. Used for all hand-worked buttonholes and button attachment.'],
          ['🐚', 'Mother-of-Pearl', 'Default buttons', 'Natural material. Smooth, polished finish. Sewn with silk thread shank.'],
          ['🦌', 'Natural Horn', 'Alternative buttons', 'Sustainable natural material. Warmer tone. Available on request.']
        ]);
    }
  };

  M['jackets-personalization'] = {
    icon: '✦', title: 'Make It Yours',
    html: function() {
      return intro('Every ready-to-wear jacket can be made personal before it ships.') +
        subhdr('Button Colour') +
        text('Select your preferred button colour at checkout. Mother-of-Pearl as standard — natural horn available. Applied to all buttons before dispatch, at no additional charge.') +
        subhdr('Monogram') +
        text('Your initials embroidered in silk thread on the inner breast pocket or jacket lining. Thread colour chosen to complement the fabric. A private mark of ownership.') +
        subhdr('Gift Packaging') +
        text('Jacket presented in full gift packaging with a handwritten card. No pricing included unless requested. Monogramming available for gift orders.') +
        cta('/pages/contact', 'Enquire About Personalisation →');
    }
  };

  M['jackets-inbox'] = {
    icon: '📦', title: "What's in the Box",
    html: function() {
      return intro('Every order leaves the studio complete and considered.') +
        grid([
          ['🧥', 'Your Jacket', 'Pressed · On Hanger', 'Inspected in the studio before packing. On a padded hanger — ready to wear.'],
          ['🧺', 'TCB Garment Bag', 'Cotton · Branded', 'A TCB cotton garment bag for storage and travel. Allows the canvas to breathe.'],
          ['🔘', 'Extra Buttons', 'Matched Set', 'MOP or horn buttons matched exactly to your jacket. Secured in an envelope.'],
          ['🪵', 'Cedar Block', 'Natural · Reusable', 'Naturally deters moths, absorbs moisture, keeps stored garments fresh.'],
          ['📋', 'Care Card', 'Garment-specific', 'Cleaning, brushing, and storage instructions for a canvas jacket.'],
          ['📦', 'Shipping Box', 'Branded', 'All items dispatched in our branded box. Gift packaging goes inside if selected.']
        ]);
    }
  };

  M['jackets-compare'] = {
    icon: '◼', title: 'Jackets — TCB vs. Industry',
    html: function() {
      return subhdr('Construction') +
        compare([
          ['Canvas type', 'Full linen canvas', 'Fused or half canvas'],
          ['Chest shaping', 'Hand pad-stitched', 'Machine glued'],
          ['Lapel roll', 'Hand-rolled canvas', 'Pressed flat / fused'],
          ['Edge stitching', 'Hand pick stitch', 'Machine topstitch'],
          ['Sleeve buttons', 'Fully functional', 'Decorative only'],
          ['Hem', 'Hand blind-stitched', 'Machine hem'],
          ['Body fit over time', 'Molds to wearer', 'Stiffens / delaminates']
        ]);
    }
  };

  M['jackets-mtm'] = {
    icon: '📐', title: 'Made to Measure — Jackets',
    html: function() {
      return intro('7 measurements. 3–4 weeks construction.') +
        subhdr('What is measured') +
        mtmRows([
          ['1', 'Chest', 'Full circumference at the widest point'],
          ['2', 'Waist', 'Natural waist for jacket suppression'],
          ['3', 'Seat', 'Full seat — jacket length and seat coverage'],
          ['4', 'Shoulder', 'Point-to-point across the back'],
          ['5', 'Sleeve length', 'Shoulder point to wrist bone'],
          ['6', 'Back length', 'Back neck to preferred jacket hem'],
          ['7', 'Neck', 'For collar shaping and shirt clearance']
        ]) +
        subhdr('Additional services') +
        text('Sleeve shortening with re-worked buttonholes: +$300. This includes cutting new vents and hand-sewing new silk buttonholes to match. MTM orders are final sale.') +
        text('One free alteration is included within 30 days of delivery. A virtual fitting is available before construction begins.') +
        cta('/pages/made-to-measure', 'Explore Made to Measure →');
    }
  };

  M['jackets-nyc'] = {
    icon: '📍', title: 'New York Workshop',
    html: function() {
      return intro('Designed. Cut. Finished. All in New York City.') +
        text('Every jacket is made in the same studio where it was designed. Canvas work, pad-stitching, pick stitching, and final quality checks all happen in the same building. No production is outsourced.') +
        text('The studio opened in 2019. Every production decision since then has been made to maintain that standard.');
    }
  };

  M['jackets-care'] = {
    icon: '🧺', title: 'Jacket Care',
    html: function() {
      return grid([
        ['🧺', 'Cleaning', 'Dry clean only', 'Water damages the linen canvas. Professional dry cleaning only.'],
        ['🪵', 'Storage', 'Wide wooden hanger', 'Wire hangers distort the shoulder shape over time. Always wide wooden.'],
        ['🪮', 'After each wear', 'Garment brush', 'Brush gently to remove dust and restore nap. Two minutes extends the garment significantly.'],
        ['🌬️', 'Airing', '24 hours minimum', 'Allow jacket to air before returning to wardrobe. Canvas and fabric need time to breathe.'],
        ['🚫', 'Machine wash', 'Never', 'Water saturates and damages the linen canvas. The hand-stitching cannot recover from this.'],
        ['♻️', 'Over time', 'Improves with wear', 'Full-canvas construction molds to the wearer. Proper care extends this indefinitely.']
      ]);
    }
  };

  /* ════════ SUITS ════════ */

  M['suits-glance'] = {
    icon: '⚡', title: 'Suits — At a Glance',
    html: function() {
      return stat('2', 'garments', 'Jacket + Trouser',
          'Both pieces designed, cut, and constructed in the same studio. Outer fabric matched across both garments. Lining and interlining selected to work together.') +
        stat('4–5', 'weeks', 'MTM Construction',
          'Both pieces built simultaneously. 4–5 weeks for a complete suit reflects the work involved in two garments built to the same standard.') +
        stat('15', 'measurements', 'Full MTM (7+8)',
          '7 for the jacket, 8 for the trouser. Most brands measure one point — the chest. We map 15 dimensions before cutting.') +
        stat('30', 'day', 'Alteration Guarantee',
          'One free alteration within 30 days of delivery on MTM orders. The team reviews the fit and resolves any issue at no additional cost.');
    }
  };

  M['suits-quote'] = {
    icon: '—', title: 'The Approach',
    html: function() {
      return intro('From the <em>canvassed chest piece</em> to the hand-finished lapels and the silk-lined trouser fronts — each detail reveals itself differently in every dimension.') +
        text('A suit is two garments that have to work as one. The jacket has to drape correctly when the trouser pulls. The trouser has to sit cleanly at the waistband when the jacket is buttoned. They are engineered together, not assembled separately and matched afterward.') +
        text('Every detail in each piece serves the suit as a whole.');
    }
  };

  M['suits-journey'] = {
    icon: '📍', title: 'From Studio to You',
    html: function() {
      return steps([
        ['01', 'Design', 'Both jacket and trouser patterns drafted together. Silhouette, proportions, and fit engineered as a unit.'],
        ['02', 'Fabric', 'Outer fabric selected for both pieces from the same bolt. Canvas weight and lining sourced separately.'],
        ['03', 'Cutting', 'Jacket and trouser panels cut together. Grain direction, pattern matching, and nap direction checked across both.'],
        ['04', 'Jacket canvas work', 'Full linen canvas assembled. Hand pad-stitching shapes the chest piece. Lapel set and rolled by hand.'],
        ['05', 'Trouser construction', 'Silk-lined fronts applied. Waistband curtain built in-house. Multi-button fly set. Cotton crotch lining added.'],
        ['06', 'Finishing', 'Both garments finished. Jacket pick-stitched, hemmed, buttoned. Trouser hemmed (if selected at checkout).'],
        ['07', 'Quality review', 'Canvas, lining, hem, buttonholes, and seams reviewed on both pieces before dispatch.']
      ]);
    }
  };

  M['suits-jacket-construction'] = {
    icon: '🏗', title: 'Suit Jacket — Construction',
    html: function() {
      return grid([
        ['📐', 'Pattern', 'In-House', 'Jacket and trouser patterns drafted as a matched set.'],
        ['🏗️', 'Full Linen Canvas', 'Full Canvas', 'Spans the entire chest. Hand pad-stitched and hand-rolled lapel.'],
        ['✍️', 'Pick Stitching', 'All Edges', 'Fine hand work along every jacket edge.'],
        ['🔧', 'Sleeve Vents', 'Working', '4 functional stacked buttons per sleeve.'],
        ['🧠', 'Inner Pockets', 'iPhone-sized chest', 'Positioned to not affect silhouette or balance.'],
        ['🪡', 'Buttons', 'MOP / Horn', 'Silk thread. Three-point stitch. Hand-formed shank.']
      ]);
    }
  };

  M['suits-trouser-construction'] = {
    icon: '✨', title: 'Suit Trouser — Construction',
    html: function() {
      return grid([
        ['✨', 'Silk Lining', 'Front panels', 'Silk lining from waist to knee on both front panels. Cleaner drape, smoother movement.'],
        ['🎗️', 'Waistband Curtain', 'Built in-house', 'Not a generic insert. Constructed from scratch with matched lining fabric.'],
        ['🔒', 'Fly Closure', 'Multi-button', 'Internal multi-button closure with extended fly. Clean flat front.'],
        ['🧶', 'Crotch Lining', 'Cotton', 'Reinforcement and comfort layer. Rarely included at this price point.'],
        ['🪡', 'Buttons', 'MOP / Horn', 'Hand-sewn silk thread. Waistband, back pockets, coin pocket.'],
        ['👖', 'Hemming', 'Hand-finished', 'Available at checkout. Trousers ship unhemmed by default.']
      ]);
    }
  };

  M['suits-techniques'] = {
    icon: '🏗', title: 'Suit Techniques',
    html: function() {
      return grid([
        ['🏗️', 'Canvas', 'Full Linen', 'Jacket chest. Hand pad-stitched and rolled.'],
        ['🤝', 'Pad-Stitching', 'By Hand', 'Chest piece shaped before assembly.'],
        ['✨', 'Silk Lining', 'Trouser Front', 'Both front panels from waist to knee.'],
        ['🎗️', 'Waistband', 'In-House', 'Built from scratch. Matched lining.'],
        ['✍️', 'Pick Stitch', 'All Jacket Edges', 'Signature hand detail.'],
        ['🔧', 'Sleeve Vents', 'Working', '4 per sleeve. Fully functional.'],
        ['🪡', 'Buttons', 'MOP / Horn', 'Hand-sewn. Silk thread shank.'],
        ['🧶', 'Crotch Lining', 'Cotton', 'Comfort reinforcement on trouser.']
      ]);
    }
  };

  M['suits-bignum'] = {
    icon: '📐', title: 'MTM Precision',
    html: function() {
      return intro('15 measurements total. 7 for the jacket, 8 for the trouser.') +
        subhdr('Jacket measurements') +
        mtmRows([
          ['1', 'Chest', 'Full circumference'], ['2', 'Waist', 'Jacket suppression point'],
          ['3', 'Seat', 'Coverage and length'], ['4', 'Shoulder', 'Point to point'],
          ['5', 'Sleeve length', 'Shoulder to wrist'], ['6', 'Back length', 'Neck to hem'],
          ['7', 'Neck', 'Collar and shirt clearance']
        ]) +
        subhdr('Trouser measurements') +
        mtmRows([
          ['1', 'Waist', 'True trouser waist'], ['2', 'Seat', 'Full seat circumference'],
          ['3', 'Thigh', 'Widest thigh point'], ['4', 'Inseam', 'Crotch to floor (unhemmed)'],
          ['5', 'Outseam', 'Waist to floor'], ['6', 'Rise', 'Crotch depth'],
          ['7', 'Knee width', 'At knee level'], ['8', 'Hem width', 'Opening width at hem']
        ]) +
        subhdr('Construction & Guarantee') +
        text('A full suit is built in 4–5 weeks — both pieces together, matched in material and proportion. Sleeve shortening with hand-sewn buttonholes is +$300. One free alteration is included within 30 days of delivery; MTM orders are final sale.') +
        cta('/pages/made-to-measure', 'Explore Made to Measure →');
    }
  };

  M['suits-mtm'] = M['suits-bignum'];

  M['suits-materials'] = {
    icon: '🌿', title: 'Suit Materials',
    html: function() {
      return intro('Two garments. Every material sourced from nature.') +
        grid([
          ['🏭', 'Outer Fabric', 'Matched bolt', 'Jacket and trouser cut from the same bolt — grain direction and pattern matched across both pieces.'],
          ['🌿', 'Full Linen Canvas', 'Jacket structure', 'Hand pad-stitched. Spans the entire chest. Molds to your body over time.'],
          ['✨', 'Silk Lining', 'Jacket + trouser fronts', 'Jacket interior and both trouser front panels from waist to knee.'],
          ['🧶', 'Cotton', 'Crotch lining', 'Reinforcement and comfort layer at the trouser crotch.'],
          ['🥚', 'Silk Thread', 'Buttonholes & buttons', 'All hand-worked buttonholes and button attachment across both pieces.'],
          ['🐚', 'Mother-of-Pearl', 'Default buttons', 'Natural MOP on jacket and trouser. Sewn with silk thread shank.'],
          ['🦌', 'Natural Horn', 'Alternative', 'Sustainable. Warmer tone. Available on request.']
        ]);
    }
  };

  M['suits-personalization'] = {
    icon: '✦', title: 'Make It Yours',
    html: function() {
      return intro('Every ready-to-wear suit can be made personal before it ships.') +
        subhdr('Button Colour') +
        text('Select your preferred button colour at checkout. Applied to all buttons across both jacket and trousers before dispatch — no additional charge.') +
        subhdr('Monogram') +
        text('Your initials embroidered in silk thread. Placement options: jacket inner breast pocket or lining, trouser inner waistband. Thread colour matched to the fabric.') +
        subhdr('Gift Packaging') +
        text('Both pieces presented in full gift packaging with a handwritten card. No pricing included unless requested. Monogramming available for gift orders.') +
        cta('/pages/contact', 'Enquire About Personalisation →');
    }
  };

  M['suits-inbox'] = {
    icon: '📦', title: "What's in the Box",
    html: function() {
      return intro('Both pieces leave the studio together, complete.') +
        grid([
          ['🧥', 'Your Suit', 'Both Pieces', 'Jacket on padded hanger, trousers folded in tissue. Both inspected before packing.'],
          ['🧺', 'TCB Garment Bag', 'Cotton · Branded', 'For storage and travel. Protects both pieces while allowing the canvas to breathe.'],
          ['🔘', 'Extra Buttons', 'Matched Set', 'MOP or horn buttons for jacket and trousers. Secured in a small envelope.'],
          ['🪵', 'Cedar Block', 'Natural · Reusable', 'Naturally deters moths, absorbs moisture, keeps stored garments fresh.'],
          ['📋', 'Care Card', 'Both garments', 'Jacket and trouser care instructions — canvas construction and silk lining.'],
          ['📦', 'Shipping Box', 'Branded', 'All items dispatched in our branded box. Gift packaging goes inside if selected.']
        ]);
    }
  };

  M['suits-compare'] = {
    icon: '◼', title: 'Suits — TCB vs. Industry',
    html: function() {
      return subhdr('Construction') +
        compare([
          ['Jacket canvas', 'Full linen canvas', 'Fused or half canvas'],
          ['Chest construction', 'Hand pad-stitched', 'Machine / glued'],
          ['Trouser lining', 'Silk fronts + cotton crotch', 'Unlined or synthetic'],
          ['Sleeve buttons', 'Fully functional', 'Decorative only'],
          ['Waistband', 'In-house curtain, matched lining', 'Generic elastic / standard insert'],
          ['MTM measurements', '15 total (7+8)', 'Chest size only'],
          ['Made in', 'New York', 'Overseas factory']
        ]);
    }
  };

  M['suits-nyc'] = M['shirts-nyc'];

  M['suits-care'] = {
    icon: '🧺', title: 'Suit Care',
    html: function() {
      return grid([
        ['🧺', 'Jacket', 'Dry clean only', 'Water damages the linen canvas. Professional dry cleaning only.'],
        ['👖', 'Trousers', 'Dry clean recommended', 'Cold gentle machine wash acceptable for cotton-blend fabrics. Do not tumble dry.'],
        ['🪵', 'Storage', 'Jacket on wooden hanger', 'Trousers on clamp hanger or folded cleanly. Never wire hangers.'],
        ['🪮', 'After each wear', 'Brush jacket', 'Two minutes with a garment brush removes dust and maintains the nap.'],
        ['🌬️', 'Airing', '24 hours', 'Allow both pieces to air before storing. Canvas and silk lining need time to recover.'],
        ['♻️', 'Over time', 'Canvas improves', 'Full-canvas jacket molds to the wearer with proper care.']
      ]);
    }
  };

  /* ════════ TROUSERS ════════ */

  M['trousers-glance'] = {
    icon: '⚡', title: 'Trousers — At a Glance',
    html: function() {
      return stat('Silk', 'Lined Fronts', 'Both Front Panels',
          'Silk lining applied to both front trouser panels from waist to knee. The trouser slides on cleanly, moves with less resistance, and drapes with a cleaner line throughout the day.') +
        stat('8', 'measurements', 'MTM Precision',
          'Waist, seat, thigh, inseam, outseam, rise, knee width, hem width. Eight dimensions before construction begins.') +
        stat('In-House', 'Waistband', 'Built from Scratch',
          'Not a generic waistband insert. Constructed in the studio from lining fabric matched to each style. Light, flexible, and shaped to maintain its form throughout the day.') +
        stat('Free', 'Hemming', 'With Every Order',
          'Trousers ship unhemmed by default. Select hemming at checkout with your inseam measurement and the trouser arrives hand-finished to your length.');
    }
  };

  M['trousers-quote'] = {
    icon: '—', title: 'The Approach',
    html: function() {
      return intro('A trouser that fits well doesn\'t just look right — it <em>disappears.</em>') +
        text('You stop thinking about it. The waistband sits where it should. The seat does not pull when you sit. The thigh has enough room to move without excess fabric. The crease holds. The silk lining means nothing catches against the leg.') +
        text('That is the standard. Everything in the construction serves it.');
    }
  };

  M['trousers-journey'] = {
    icon: '📍', title: 'From Studio to You',
    html: function() {
      return steps([
        ['01', 'Design', 'Pattern drafted in-house. Silhouette, rise, and leg opening engineered for the range of movements the trouser will need to accommodate.'],
        ['02', 'Fabric', 'Outer fabric and silk lining sourced separately. Waistband lining fabric selected to match the outer.'],
        ['03', 'Cutting', 'All panels — outer, silk front lining, waistband — cut against individual patterns.'],
        ['04', 'Construction', 'Silk lining applied to front panels. Waistband curtain built in-house. Multi-button fly set. Cotton crotch lining added.'],
        ['05', 'Buttons & buttonholes', 'Hand-sewn on waistband, back pockets, and coin pocket. Silk thread. Three-point stitch.'],
        ['06', 'Hemming (if selected)', 'Trouser hemmed to the provided inseam measurement and finished by hand before dispatch. No additional charge.'],
        ['07', 'Quality check', 'Seams, lining, waistband, and buttons reviewed. MTM orders confirmed with team before construction begins.']
      ]);
    }
  };

  M['trousers-construction'] = {
    icon: '🏗', title: 'Trouser Construction',
    html: function() {
      return grid([
        ['📐', 'Pattern', 'In-House', '2D and 3D methods. Designed for seated and standing wear.'],
        ['✨', 'Silk Lining', 'Front Panels', 'Waist to knee. Cleaner drape and smoother movement.'],
        ['🎗️', 'Waistband', 'Built In-House', 'From scratch. Matched lining. Light and flexible.'],
        ['🔒', 'Fly', 'Multi-Button', 'Internal closure with extended fly. Clean flat front.'],
        ['🧶', 'Crotch Lining', 'Cotton', 'Reinforcement layer for comfort and durability.'],
        ['🪡', 'Buttons', 'MOP / Horn', 'Hand-sewn. Silk thread. Three-point anchor stitch.'],
        ['👜', 'Interior pockets', 'Waistband built-in', 'Small pockets inside waistband curtain.'],
        ['👖', 'Hemming', 'Hand-finished', 'Available at checkout. Shipped unhemmed by default.']
      ]);
    }
  };

  M['trousers-techniques'] = {
    icon: '🏗', title: 'Trouser Techniques',
    html: function() {
      return grid([
        ['📐', 'Pattern', '2D + 3D', 'In-house. Designed for range of motion.'],
        ['✨', 'Silk Lining', 'Front Only', 'Waist to knee on both panels.'],
        ['🎗️', 'Waistband', 'In-House', 'Built from scratch. Not a generic insert.'],
        ['🔒', 'Fly', 'Multi-Button', 'Extended fly. Clean flat front.'],
        ['🧶', 'Crotch Lining', 'Cotton', 'Comfort and reinforcement.'],
        ['🪡', 'Buttonholes', 'Silk Thread', 'Waistband, back pockets, coin pocket.'],
        ['👖', 'Hemming', 'Hand-Finished', 'Free with every order.'],
        ['🎯', 'Waistband pockets', 'Built-In', 'Inside curtain. Discreet utility.']
      ]);
    }
  };

  M['trousers-bignum'] = {
    icon: '📐', title: 'MTM Precision — Trousers',
    html: function() {
      return intro('8 measurements. Most brands measure one: the waist.') +
        subhdr('What is measured') +
        mtmRows([
          ['1', 'Waist', 'True trouser waist — not suit jacket waist'],
          ['2', 'Seat', 'Full seat circumference at widest point'],
          ['3', 'Thigh', 'Widest thigh point for ease of movement'],
          ['4', 'Inseam', 'Crotch to floor (unhemmed reference)'],
          ['5', 'Outseam', 'Waist to floor'],
          ['6', 'Rise', 'Crotch depth — determines where waistband sits'],
          ['7', 'Knee width', 'Opening at the knee'],
          ['8', 'Hem width', 'Trouser opening at the hem']
        ]) +
        cta('/pages/made-to-measure', 'Explore Made to Measure →');
    }
  };

  M['trousers-bignum2'] = {
    icon: '👖', title: 'Complimentary Hemming',
    html: function() {
      return intro('Hand-finished hemming included with every order.') +
        text('All trousers ship unhemmed by default — ready for your preferred tailor to finish at the correct length with their preferred hem style.') +
        text('If you prefer to have them hemmed before shipping, select the hemming option at checkout and provide your inseam measurement. The trousers will be cut and finished by hand to that length before dispatch. No additional charge.') +
        text('Cuff options: add a cuff (+$150) or remove an existing cuff (complimentary). Hemmed trousers and MTM orders are final sale.');
    }
  };

  M['trousers-feature'] = M['trousers-bignum2'];

  M['trousers-mtm'] = {
    icon: '📐', title: 'Made to Measure — Trousers',
    html: function() {
      return intro('8 measurements. 3–4 weeks construction.') +
        subhdr('Cuff options') +
        text('Add cuff: +$150 · Remove existing cuff: Complimentary · No cuff: standard. Hemmed and MTM trousers are final sale.') +
        text('One free alteration is included within 30 days of delivery. A virtual fitting is available before construction begins.') +
        subhdr('What is measured') +
        mtmRows([
          ['1', 'Waist', 'True trouser waist'],
          ['2', 'Seat', 'Full seat circumference'],
          ['3', 'Thigh', 'Widest thigh point'],
          ['4', 'Inseam', 'Crotch to floor'],
          ['5', 'Outseam', 'Waist to floor'],
          ['6', 'Rise', 'Crotch depth'],
          ['7', 'Knee width', 'At knee level'],
          ['8', 'Hem width', 'Trouser opening width']
        ]) +
        cta('/pages/made-to-measure', 'Explore Made to Measure →');
    }
  };

  M['trousers-materials'] = {
    icon: '🌿', title: 'Trouser Materials',
    html: function() {
      return intro('Natural materials throughout. Built to be worn.') +
        grid([
          ['🏭', 'Outer Fabric', 'Premium Mill', 'Sourced from established woven-fabric mills. Weight and weave selected per style.'],
          ['✨', 'Silk Lining', 'Front panels', 'Silk applied to both front trouser panels from waist to knee. Cleaner drape, smoother wear.'],
          ['🧶', 'Cotton', 'Crotch lining', 'Comfort and reinforcement layer. Rarely included at this price point.'],
          ['🥚', 'Silk Thread', 'Buttonholes & buttons', 'All hand-worked buttonholes and button attachment. Natural fibre, consistent tension.'],
          ['🐚', 'Mother-of-Pearl', 'Default buttons', 'Natural material. Applied at waistband, back pockets, and coin pocket.'],
          ['🦌', 'Natural Horn', 'Alternative buttons', 'Sustainable natural material. Warmer tone. Available on request.']
        ]);
    }
  };

  M['trousers-personalization'] = {
    icon: '✦', title: 'Make It Yours',
    html: function() {
      return intro('Every ready-to-wear trouser can be made personal before it ships.') +
        subhdr('Button Colour') +
        text('Select your preferred button colour at checkout. Applied to all buttons — waistband, back pockets, fly, and coin pocket — before dispatch. No additional charge.') +
        subhdr('Monogram') +
        text('Your initials embroidered in silk thread on the inner waistband. Thread colour matched to the lining fabric. Discreet, personal, and permanent.') +
        subhdr('Gift Packaging') +
        text('Trousers pressed and presented in full gift packaging with a handwritten card. No pricing included unless requested. Monogramming available for gift orders.') +
        cta('/pages/contact', 'Enquire About Personalisation →');
    }
  };

  M['trousers-inbox'] = {
    icon: '📦', title: "What's in the Box",
    html: function() {
      return intro('Every order leaves the studio complete and considered.') +
        grid([
          ['👖', 'Your Trousers', 'Pressed · Folded', 'Inspected in the studio before packing. Folded and wrapped in tissue.'],
          ['🧺', 'TCB Travel Bag', 'Cotton · Branded', 'A TCB cotton bag sized for folded trousers. Keeps them clean and compact in luggage.'],
          ['🔘', 'Extra Buttons', 'Matched Set', 'MOP or horn buttons matched to your trousers. Secured in a small envelope.'],
          ['🪵', 'Cedar Block', 'Natural · Reusable', 'Naturally deters moths, absorbs moisture, keeps stored garments fresh.'],
          ['📋', 'Care Card', 'Garment-specific', 'Cleaning, pressing, and storage instructions for silk-lined trousers.'],
          ['📦', 'Shipping Box', 'Branded', 'All items dispatched in our branded box. Gift packaging goes inside if selected.']
        ]);
    }
  };

  M['trousers-compare'] = {
    icon: '◼', title: 'Trousers — TCB vs. Industry',
    html: function() {
      return subhdr('Construction') +
        compare([
          ['Front lining', 'Silk-lined throughout', 'Unlined or synthetic'],
          ['Waistband', 'In-house curtain, matched lining', 'Generic insert'],
          ['Crotch', 'Cotton reinforced lining', 'Unfinished / bare'],
          ['Fly', 'Multi-button internal closure', 'Single hook or standard zip'],
          ['Buttons', 'MOP or horn · silk thread', 'Plastic · machine-sewn'],
          ['Hem at RTW', 'Unhemmed + free hand-finish option', 'Fixed standard hem'],
          ['MTM measurements', '8 precise points', 'Waist size only']
        ]);
    }
  };

  M['trousers-nyc'] = M['shirts-nyc'];

  M['trousers-care'] = {
    icon: '🧺', title: 'Trouser Care',
    html: function() {
      return grid([
        ['🧺', 'Cleaning', 'Dry clean recommended', 'Cold gentle machine wash acceptable for cotton-blend fabrics. Do not tumble dry.'],
        ['🌡️', 'Pressing', 'Low iron with pressing cloth', 'Press along the crease — not across it. Damp cloth between iron and fabric.'],
        ['🪵', 'Storage', 'Clamp hanger or folded', 'Hang on a clamp hanger to preserve the crease. Never crumple.'],
        ['🌬️', 'After wearing', 'Air before storing', 'Allow a few hours of air. The silk lining breathes — give it time to recover.'],
        ['💧', 'Stain treatment', 'Cold water, immediately', 'Blot — do not rub. Take to a professional cleaner as soon as possible.'],
        ['♻️', 'Silk lining', 'Self-maintaining', 'The silk front lining does not require special care beyond the garment itself.']
      ]);
    }
  };

  /* ── Modal open / close ───────────────────────────────────────── */
  var wrap, sheet, bodyEl, titleEl, iconEl;

  function getEls() {
    if (!wrap) {
      wrap   = document.getElementById('cpModalWrap');
      sheet  = document.getElementById('cpModalSheet');
      bodyEl = document.getElementById('cpModalBody');
      titleEl= document.getElementById('cpModalTitle');
      iconEl = document.getElementById('cpModalIcon');
    }
  }

  window.cpOpenModal = function(id) {
    var m = M[id];
    if (!m) return;
    getEls();
    titleEl.textContent = m.title;
    iconEl.textContent  = m.icon;
    bodyEl.innerHTML    = m.html();
    bodyEl.scrollTop    = 0;
    wrap.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // Re-animate sheet
    sheet.style.animation = 'none';
    sheet.offsetHeight;
    sheet.style.animation = '';
  };

  window.cpCloseModal = function() {
    getEls();
    if (!wrap) return;
    wrap.setAttribute('hidden', '');
    document.body.style.overflow = '';
  };

  /* ── Auto-bind cards to modal IDs ───────────────────────────── */
  function detectModalId(el) {
    var panel = el.closest('.cp-panel');
    if (!panel) return null;
    var cat = panel.id.replace('cp-panel-', '');

    var lbl = el.querySelector('.cp-card-label');
    if (!lbl) return null;
    var t = lbl.textContent.trim().toUpperCase();

    if (t.includes('AT A GLANCE'))           return cat + '-glance';
    if (t.includes('FROM STUDIO'))           return cat + '-journey';
    if (t.includes('TCB INNOVATION'))        return cat + '-feature';
    if (t.includes('FULL LINEN CANVAS'))     return cat + '-feature';
    if (t.includes('HEMMING SERVICE'))       return cat + '-feature';
    if (t.includes('TECHNIQUES'))            return cat + '-techniques';
    if (t.includes('SCULPTED FIT'))           return cat + '-fit';
    if (t.includes('CONSTRUCTION') && t.includes('JACKET') && cat === 'suits') return 'suits-jacket-construction';
    if (t.includes('CONSTRUCTION') && t.includes('TROUSER')) return 'suits-trouser-construction';
    if (t.includes('CONSTRUCTION'))          return cat + '-construction';
    if (t.includes('TCB VS') || t.includes('VS. INDUSTRY')) return cat + '-compare';
    if (t.includes('MADE TO MEASURE'))       return cat + '-mtm';
    if (t.includes('CARE'))                  return cat + '-care';
    if (t.includes('NEW YORK WORKSHOP'))     return cat + '-nyc';
    if (t.includes('STITCH DENSITY'))        return cat + '-26spi';
    if (t.includes('BUTTONS') && t.includes('BUTTONHOLES')) return cat + '-20min';
    if (t.includes('PER BUTTONHOLE'))        return cat + '-20min';
    if (t.includes('SLEEVE BUTTONS'))        return cat + '-4buttons';
    if (t.includes('CANVAS LIFESPAN'))       return cat + '-lifespan';
    if (t.includes('MTM MEASUREMENTS') || t.includes('CONSTRUCTION TIME')) return cat + '-bignum';
    if (t.includes('MTM PRECISION') || t.includes('HEMMING SERVICE') && cat !== 'shirts') return cat + '-bignum2';
    if (t.includes('SHIRT MATERIALS') || t.includes('JACKET MATERIALS') || t.includes('SUIT MATERIALS') || t.includes('TROUSER MATERIALS')) return cat + '-materials';
    if (t.includes('MAKE IT YOURS'))          return cat + '-personalization';
    if (t.includes('IN THE BOX'))             return cat + '-inbox';
    if (el.classList.contains('cp-quote'))   return cat + '-quote';
    return null;
  }

  function autoBindCards() {
    document.querySelectorAll('.cp-card').forEach(function(el) {
      /* Prefer an explicit data-modal set in markup; fall back to label detection */
      var id = el.getAttribute('data-modal') || detectModalId(el);
      if (!id || !M[id]) return;
      el.setAttribute('data-modal', id);
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.addEventListener('click', function() { window.cpOpenModal(id); });
      el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.cpOpenModal(id); }
      });
    });
  }

  /* ── Keyboard close ──────────────────────────────────────────── */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') window.cpCloseModal();
  });

  /* ── Init ────────────────────────────────────────────────────── */
  function initModals() {
    autoBindCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModals);
  } else {
    initModals();
  }

}());
